import { cn } from '@/utils/shared/Utils';
import { InputProps } from '@/types/form/input-props';
import { Input } from './input';
import { InputErrors } from './input-errors';

type TextInputProps = InputProps<string> & {
  adornment?: React.ReactNode;
  hint?: React.ReactNode;
};

export function TextInput({
  name,
  label,
  value,
  onBlur,
  onChange,
  required,
  className,
  errors,
  adornment,
  hint,
  ...rest
}: TextInputProps) {
  const isError = !!errors.length;

  return (
    <div className="space-y-1">
      <div className={cn('group relative', className)}>
        <label
          htmlFor={name}
          className="origin-start text-muted-foreground/70 group-focus-within:text-foreground has-[+input:not(:placeholder-shown)]:text-foreground absolute top-1/2 block -translate-y-1/2 cursor-text px-1 text-sm transition-all group-focus-within:pointer-events-none group-focus-within:top-0 group-focus-within:cursor-default group-focus-within:text-xs group-focus-within:font-medium has-[+input:not(:placeholder-shown)]:pointer-events-none has-[+input:not(:placeholder-shown)]:top-0 has-[+input:not(:placeholder-shown)]:cursor-default has-[+input:not(:placeholder-shown)]:text-xs has-[+input:not(:placeholder-shown)]:font-medium"
        >
          <span className="bg-background inline-flex px-2">{label}</span>
        </label>
        <Input
          id={name}
          key={name}
          name={name}
          placeholder=" "
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          className={cn(
            'focus-visible:border-primary focus-visible:ring-[color:color-mix(in_oklab,var(--primary)_50%,transparent)]',
            adornment && 'pr-9',
            isError && 'border-red-600/80 text-red-600 focus-visible:border-red-600/80 focus-visible:ring-red-600/20',
          )}
          {...rest}
        />
        {adornment && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">{adornment}</div>
        )}
      </div>
      {isError ? <InputErrors errors={errors} /> : hint}
    </div>
  );
}
